import { createSelector } from '@ngrx/store'

export const getLoginState = createSelector(
  (state: any) => state.auth,
  (state: any) => state.get('login'),
)

export const getRequestPasswordResetState = createSelector(
  (state: any) => state.auth,
  (state: any) => state.get('requestPasswordReset'),
)

export const getPasswordResetState = createSelector(
  (state: any) => state.auth,
  (state: any) => state.get('passwordReset'),
)

export const getIsAuthenticatedState = createSelector(
  (state: any) => state.auth,
  (state: any) => state.get('isAuthenticated'),
)
